import diaporamaElement from "../element/diaporama.js";
import printContainer from "../item/printContainer.js";
import dynamicImage from "../element/dynamic/image.js";
import containerItem from "../item/container.js";
import videoElement from "../element/video.js";
import imageElement from "../element/image.js";
import textElement from "../element/text.js";
import gridElement from "../element/grid.js";
import colorElement from "../element/color.js";
import positionItem from "../item/position.js";
import shadowItem from "../item/shadow.js";
import sizeItem from "../item/size.js";

export default [
    {
        name: "Container",
        description: "Layer",
        type: "ContainerItem",
        iconSVG: "blockchainIcon",
        subType: [
            { type: "^.*Element$", property: "Contents", is: "array" },
            { type: "PositionItem", property: "Position", is: "object" }
        ],
        constructor: containerItem,
    },
    {
        name: "PrintContainer",
        description: "Container pour l'impression",
        type: "PrintContainerItem",
        iconSVG: "printIcon",
        subType: [
            { type: "^.*Element$", property: "Contents", is: "array" },
            { type: "PositionItem", property: "Position", is: "object" }
        ],
        constructor: printContainer,
    },
    {
        name: "Diaporama",
        description: "un diaporama",
        type: "DiaporamaElement",
        iconSVG: "galleryIcon",
        subType: [
            { type: "^(?!(Grid)|(Diaporama)).*Element$", property: "Diaporama", is: "array" },
        ],
        constructor: diaporamaElement,
    },
    {
        name: "DynamicImage",
        description: "Element dynamique",
        type: "DynamicImage",
        ignoreOnStandardElement: true,
        iconSVG: null,
        subType: [
            { type: "Shadow", property: "Shadow", is: "object" }
        ],
        constructor: dynamicImage,
    },
    {
        name: "Image",
        description: "une image",
        type: "ImageElement",
        iconSVG: "imageGalleryIcon",
        subType: [
            { type: "Shadow", property: "Shadow", is: "object" }
        ],
        constructor: imageElement,
    },
    {
        name: "Text",
        description: "un texte",
        type: "TextElement",
        iconSVG: "textIcon",
        subType: [
            { type: "Shadow", property: "Shadow", is: "object" }
        ],
        constructor: textElement,
    },
    {
        name: "Grille",
        description: "une grille d'élément",
        type: "GridElement",
        iconSVG: "gridIcon",
        subType: [
            { type: "^(?!Grid).*Element$", property: "Contents", is: "array" },
            { type: "Shadow", property: "Shadow", is: "object" }
        ],
        constructor: gridElement,
    },
    {
        name: "Video",
        description: "Block video",
        type: "VideoElement",
        iconSVG: "playIcon",
        subType: [
            { type: "Shadow", property: "Shadow", is: "object" },
        ],
        constructor: videoElement,
    },
    {
        name: "Position",
        description: "une position",
        type: "Position",
        iconSVG: "arrowsIcon",
        subType: [],
        constructor: positionItem,
    },
    {
        name: "Size",
        description: "une taille",
        type: "Size",
        iconSVG: "arrowsIcon",
        subType: [],
        constructor: sizeItem,
    },
    {
        name: "Shadow",
        description: "une ombre",
        type: "Shadow",
        iconSVG: "shadowIcon",
        subType: [],
        constructor: shadowItem,
    },
    {
        name: "Color",
        description: "une couleur de fond",
        type: "ColorElement",
        iconSVG: "colorIcon",
        subType: [
            { type: "Shadow", property: "Shadow", is: "object" }
        ],
        constructor: colorElement,
    },
];

